<template>
  <div>
    <b-card-body>
      <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
        <div id="paper" class="mb-3 p-5 background-white text-secondary componentview">
          <b-button-group>
            <b-button class="mr-1" squared size="sm" variant="primary" @click="download()">
              <i :class="busy
                ? 'fa fa-spinner fa-spin pr-3'
                : 'fa fa-file-pdf-o pr-3'
                "></i>Download
              <i class="fa fa-download"></i>
            </b-button>
          </b-button-group>
          <!-- {{ data }} -->
          <div v-if="showasdraft" class="wm_container_wrapper">
            <div class="wm_container_watermark">DRAFT</div>
          </div>

          <div v-if="data">
            <b-row class="header text-muted mb-4" no-gutters>
              <b-col cols="1">
                <!-- <img
                      class="logo mt-4 ml-5 h-50px"
                      src="/img/brand/ABTA.jpg"
                      alt="ABTA"
                  /> -->
              </b-col>
              <b-col class="text-center"><img class="logo mb-3" src="/img/brand/RGB Travel Places Primary Logo.bmp"
                  alt="Travel Places" height="70" width="190" /><br />
                <span>
                  Podium House 61 Chapel Road, Worthing, West Sussex, BN11
                  1HR<br />
                  Tel Accounts: +44 (0) 1903 832 899 Tel Sales: +44 (0) 1903
                  832888 Fax: +44 (0) 1903 231743</span>
              </b-col>
              <b-col cols="1" class="mt-4 mr-5 text-right">
                <img class="logo h-30px" src="/img/brand/IATA.jpg" alt="IATA" />
              </b-col>
            </b-row>
            <div class="large">
              <b-row class="my-2" no-gutters>
                <b-col class="strong text-left">
                  {{ data.to }} <br />
                  <div v-html="$helpers.breaklines(data.address)"></div>
                </b-col>
                <b-col class="text-right">
                  <b-row>
                    <b-col><span>
                        {{ data.credit ? "Credit Note:" : "Invoice:" }}
                      </span></b-col>
                    <b-col class="strong">{{ data.ref }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Date:</b-col>
                    <b-col v-if="data.dateref" class="strong">
                      {{
                        $moment
                          .unix(data.dateref * 0.001)
                          .utc(false)
                          .format("DD-MMM-YY")
                      }}
                    </b-col>
                    <b-col v-else class="strong"> </b-col>
                  </b-row>
                  <b-row>
                    <b-col>Account:</b-col>
                    <b-col class="strong">{{ data.slac }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Consultant:</b-col>
                    <b-col class="strong">{{ data.agent }}</b-col>
                  </b-row>
                  <b-row v-if="data.booker">
                    <b-col>Booker:</b-col>
                    <b-col class="strong">{{ data.booker }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Your ref:</b-col>
                    <b-col class="strong"><span class="nowrap">{{ data.yourref }}</span>
                    </b-col>
                  </b-row>
                  <!-- <b-row>
                      <b-col>Page:</b-col>
                      <b-col>n of n</b-col>
                    </b-row> -->
                </b-col>
              </b-row>

              <b-row class="mb-2" no-gutters>
                <b-col class="text-center strong"> {{ data.eventname }}</b-col>
              </b-row>


              <table class="invoicetable rinvoice" v-if="data.document">
                <thead>
                  <tr>
                    <th v-for="(field, findex) in data.document.fields" :key="findex" class="border-right-secondary">
                      <span v-html="$helpers.breaklines(field.label)" />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <!-- SPACER -->
                  <tr class="spacer">
                    <template v-for="(col, cindex) in data.document.fields">
                      <td :key="cindex" :class="'border-right-secondary v-align-top'"></td>
                    </template>
                  </tr>
                  <tr v-for="(row, rindex) in data.document.items" :key="rindex">
                    <td v-for="(col, cindex) in row" :key="cindex" :class="data.document.fields[cindex].class +
                      ' border-right-secondary v-align-top'
                      ">
                      <span v-html="$helpers.breaklines(col)" />
                    </td>
                  </tr>
                  <!-- SPACER -->
                  <tr class="spacer">
                    <template v-for="(col, cindex) in data.document.fields">
                      <td :key="cindex" :class="'border-right-secondary v-align-top'"></td>
                    </template>
                  </tr>
                </tbody>
                <tfoot>
                  <tr v-if="data.salevat" class="strong border-top-secondary">
                    <td></td>
                    <td :colspan="data.document.fields.length - 2">
                      Total excluding VAT
                    </td>

                    <td class="text-right border-left-secondary">
                      {{ Math.abs(data.saleexvat) | currency("") }}
                    </td>
                  </tr>

                  <tr v-if="data.salevat" class="strong border-top-secondary">
                    <td></td>
                    <td :colspan="data.document.fields.length - 2">VAT</td>

                    <td class="text-right border-left-secondary">
                      {{ Math.abs(data.salevat) | currency("") }}

                    </td>
                  </tr>

                  <tr class="strong border-top-secondary">
                    <td></td>
                    <td :colspan="data.document.fields.length - 2">
                      {{ data.credit ? "Credit Note" : "Invoice" }} Total GBP
                    </td>

                    <td class="text-right border-left-secondary">
                      {{ Math.abs(data.saletotal) | currency("") }}
                    </td>
                  </tr>
                  <!-- SPACER -->

                  <tr v-if="vatreclaim" class="spacer_empty">
                    <template v-for="(col, cindex) in data.document.fields">
                      <td :key="cindex" :class="'mt-2'"></td>
                    </template>
                  </tr>

                  <tr v-if="vatreclaim">
                    <td class="border-right-secondary v-align-top"></td>
                    <td class="border-right-secondary v-align-top">
                  <tr v-if="vatreclaim"
                    style="background:transparent !important; border-top:none !important; border-bottom:none !important;">
                    <td class="border-right-secondary v-align-top text-left">Summary invoice Tax statement</td>
                    <td class="text-center">The VAT shown in this table is your input tax as shown on the supplier
                      invoice that we have
                      received. This amount can be reclaimed subject to normal VAT rules.</td>
                  </tr>
                  </td>

                  <td v-if="vatreclaim" class="border-right-secondary v-align-top text-center text-danger" colspan="3">
                    Supplier invoice
                    <br>VAT GBP
                  </td>
                  <td v-if="vatreclaim" class="border-right-secondary v-align-top text-right">{{
                    Math.abs(parseFloat(data.vatreclaim)).toFixed(2) |
                    currency("") }}</td>
                  </tr>

                </tfoot>

              </table>

              <!-- <table class="invoicetable rinvoice mt-3" v-if="vatreclaim">
                <tbody>
                  <tr>

                    <td class="border-right-secondary v-align-top">Summary invoice Tax statement</td>
                    <td class="border-right-secondary v-align-top">The VAT shown in this table is your input tax as
                      shown on the hotel
                      invoice that we have received. This amount can be reclaimed subject to normal VAT rules.</td>
                    <td class="border-right-secondary v-align-top text-danger" colspan="3">Hotel invoice input <br> VAT
                      GBP</td>
                    <td class="border-right-secondary v-align-top">1000.00</td>
                  </tr>
                </tbody>
              </table> -->


              <b-row v-if="data.refcredit" class="mt-4">
                <b-col>Related documents: {{ data.refcredit }}</b-col>
              </b-row>

              <b-row class="strong mt-4">
                <b-col>Operating under TOMS VAT scheme.</b-col>
              </b-row>

              <b-row class="strong mt-0">
                <b-col>{{ data.terms }}</b-col>
              </b-row>
              <b-row class="small strong my-0">
                <b-col>Invoices paid by Corporate credit cards will attract a 2% fee.</b-col>
              </b-row>
            </div>

            <!-- <b-row no-gutters align-h="end" class="text-right" v-for="(mifield, index) in data.mifields" :key="index">
                <b-col cols="auto">{{ mifield.label }}:</b-col>
                <b-col cols="6" class="strong">{{ mifield.value }}</b-col>
              </b-row> -->
            <!-- <b-row> -->
            <b-row class="mt-4 mb-4" v-if="data.mifields">
              <b-col cols="12" v-if="data.mifields.length>0">
                <table align="center" class="border-all-secondary">
                  <tr>
                    <td colspan="2" class="text-center strong">Additional Information</td>
                  </tr>
                  <tr class="border-top-secondary" v-for="(mifield, index) in data.mifields" :key="index">
                    <td class="border-right-secondary v-align-top pl-1 pr-1" >{{ mifield.label }}</td>
                    <td class="strong pl-1 pr-1">{{ mifield.value }} </td>
                  </tr>
                </table>
              </b-col>
            </b-row>
            <!-- </b-row> -->
            <!-- <div class="text-right" v-for="(mifield, index) in data.mifields" :key="index">

                <span>{{ mifield.label }}:</span>
                <span class="strong pl-2">{{ mifield.value }}</span>

              </div> -->
            <!-- </b-row> -->
            <!-- {{ data.mifields }} -->


            <b-row class="text-center small mt-4">
              <b-col>Note: This invoice is in &pound; Sterling currency <br />
                Payment: GBP, Bank: Lloyds Bank PLC, Sort Code: 30-00-02, A/c:
                02056572, Swift: LOYD GB 2LCTY, IBAN: GB85 LOYD 300002
                02056572<br />
                VAT Reg No: GB 413 6406 79, Company Reg No: 08774160<br />
                Travel Places, in association with American Express Global
                Business Travel
              </b-col>
            </b-row>
            <b-row class="mt-4 small">
              <b-col class="text-left">Zone: {{ data.zone }}&nbsp; {{ data.vatregion }}</b-col>
              <b-col class="text-right">
                Identifier: {{ data.id }}
              </b-col>
            </b-row>
          </div>
        </div>

      </b-overlay>
    </b-card-body>
  </div>
</template>

<script>
import gql from "graphql-tag";

import * as fs from "file-saver";

export default {
  name: "r_invoice",
  props: {
    item: { type: Object },
    invoiceno: { type: String },
    showasdraft: { type: Boolean, default: false },
  },
  data() {
    return {
      busy: false,
      modalShow: false,
      data: {},
      options: {
        title: "Render Invoice",
        icon: "fa fa-wpforms",
        debounce: 500,
      },
    };
  },
  computed: {
    vatreclaim() {
      let result = false
      if (this.data.vatreclaim) {
        if (this.data.vatreclaim != '0.00') {
          result = true
        }
      }
      return result
    }
  },
  watch: {
    item: {
      immediate: true,
      async handler(newVal, oldVal) {
        this.data = newVal;
      },
    },
    invoiceno: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (newVal) {
          await this.render(newVal);
        }
      },
    },
  },
  methods: {
    async render(invoiceno) {
      this.busy = true;
      console.log('render')
      let variables = {
        ref: invoiceno,
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query SLTransactions($ref: String) {
              SLTransactions(ref: $ref) {
                id
                typeinv
                credit
                ref
                dateref
                slac
                eventname
                agent
                booker
                yourref
                to
                address
                terms
                refcredit
                bltype
                zone
                vatregion
                vatreclaim
                saleexvat
                salevat
                saletotal
                mifields {
                  label
                  value
                }
                document {
                  fields {
                    key
                    label
                    class
                  }
                  items
                }
              }
            }
          `,
          variables,
          fetchPolicy: "no-cache",
        });

        this.data = response.data.SLTransactions[0];
        if (this.data.salevat == 0) { this.data.salevat = "" }


      } catch (error) {
        console.log(error);
      }

      this.busy = false;
    },
    async download() {
      this.busy = true;

      let documentpdf = null
      let documentformat = "INV_1"
      let documentname = ""

      if (this.showasdraft) {

        if (this.item.documentpdf) {
          documentpdf = this.item.documentpdf
          documentname = "draft_" + this.item.ref.split('*').join('') + ".pdf"
        }


      } else {
        let variables = {
          ref: this.invoiceno,
          documentformat
        };

        try {
          const response = await this.$apollo.query({
            query: gql`
            query SLTransactions($ref: String, $documentformat: String) {
              SLTransactions(ref: $ref, documentformat: $documentformat) {
                id
                ref
                documentpdf
              }
            }
          `,
            variables,
          });
          if (response.data.SLTransactions.length > 0) {
            documentpdf = response.data.SLTransactions[0].documentpdf
            documentname = "invoice_" + response.data.SLTransactions[0].ref + ".pdf"
          }
        } catch (error) {
          console.log(error);
        }

      }

      if (documentpdf) {
        let byteCharacters = atob(documentpdf);
        let byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        let blob = new Blob([byteArray], { type: "application/pdf" });
        fs.saveAs(blob, documentname);
      }

      this.busy = false;
    },
  },
};
</script>

<style></style>